import Rete from 'rete';

export const distSocket = new Rete.Socket('Distribution');

// Rete Controls
export { default as TextControl } from './TextControl';
export { default as NumControl } from './NumControl';
export { default as SelectControl } from './SelectControl';
export { default as ConditionalNumControl } from './ConditionalNumControl';
export { default as DistPreviewControl } from './DistPreviewControl';

// Rete Components
export { default as InputComponent } from './InputComponent';
export { default as ModuleComponent } from './ModuleComponent';
export { default as OutputComponent } from './OutputComponent';
export { default as NumComponent } from './NumComponent';
export { default as SquareDistComponent } from './SquareDistComponent';
export { default as TriangleDistComponent } from './TriangleDistComponent';
export { default as NormDistComponent } from './NormDistComponent';
export { default as ExpDistComponent } from './ExpDistComponent';
export { default as AddComponent } from './AddComponent';
export { default as ResultComponent } from './ResultComponent';	
export { default as SubtractComponent } from './SubtractComponent';
export { default as MultiplyComponent } from './MultiplyComponent';
export { default as DivideComponent } from './DivideComponent';
export { default as PowerComponent } from './PowerComponent';
export { default as IfNullComponent } from './IfNullComponent';
export { default as SwitchComponent } from './SwitchComponent';
export { default as MixerComponent } from './MixerComponent';


// Growth Rate Const

export const selectGrowthRate = [
	{ text: 'No change', value: 'constant' },
	{ text: 'Fix growth rate', value: 'growthrate' },
	{ text: 'Individual distributions', value: 'individual' }
];
